import { fireClearCodeEvent, goToPage } from "../../../editor/events";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "./wrapper";

import type { StepType } from "@reactour/tour";
import { typeSomeText } from "../../common";

const stories: (arg0: string) => StepType[] = (hostId: string) => [
	{
		selector: ".author-root",
		position: "center",
		content: () => <TourStepContent description={() => <strong>{text.tourSteps.storiesTitle}</strong>} />,
		action: () => {
			goToPage(hostId, "QP", 1);
			fireClearCodeEvent();
			typeSomeText({ text: " " });
		},
	},
	{
		selector: "#control-stories",
		content: () => <TourStepContent description={() => text.tourSteps.storiesWeCallStories} />,
	},
	{
		selector: "#control-stories",
		content: () => <TourStepContent description={() => text.tourSteps.storiesClickToOpen} />,
		action: () => {
			const btn = document.getElementById("control-stories");
			btn?.click();
		},
	},
	{
		selector: "#stories",
		content: () => <TourStepContent description={() => text.tourSteps.storiesViewAll} />,
	},
	{
		selector: ".file-link",
		content: () => <TourStepContent description={() => text.tourSteps.storiesClickToEdit} />,
	},
	{
		selector: ".story-modal--controls",
		content: () => <TourStepContent description={() => text.tourSteps.storiesCreateOrClose} />,
		actionAfter: () => {
			const btn = document.getElementById("control-stories");
			btn?.click();
		},
	},
];

export default stories;
